export interface EmployersData {
  addingEnabled: boolean;
  employers: Employer[];
}

export interface Employer {
  id?: string;
  companyName: string;
  companyNumber: string;
}

export interface EmployerExt {
  qr: string;
  qrClient: string;
  employer: {
    id?: string;
    companyName: string;
    companyNumber: string;
  }
}

export const initialValues = {
  companyName: '',
  companyNumber: ''
};
